import React, { useRef } from 'react';
import Yannik from '../../assets/images/yannik.jpeg';
import Jacque from '../../assets/images/jk.jpeg';
import Timothee from '../../assets/images/timothee.jpeg';
import David from '../../assets/images/david.jpeg';
import Julia from '../../assets/images/Julia.jpeg';
import Ebrille from '../../assets/images/Ebrille.jpeg';
import Peter from '../../assets/images/Peter.jpeg';
import Rhenard from '../../assets/images/rhenard.jpeg';


const TeamSection = () => {
  const cardContainerRef = useRef(null);

  const scrollLeft = () => {
    cardContainerRef.current.scrollBy({ left: -900, behavior: 'smooth' });
  };

  const scrollRight = () => {
    cardContainerRef.current.scrollBy({ left: 900, behavior: 'smooth' });
  };

  return (
    <div className='team container'>
      <div className='team__title'>
        <h3 className='mb-3'>Notre équipe</h3>
      </div>
      <div className='team_text'>
        <p>
          Nos équipes, composées de plus d'une centaine d'enquêteurs 
          sur le terrain et d'experts multidisciplinaires, travaillent en étroite 
          collaboration pour mener à bien nos missions.
        </p>
      </div>
      <div className='team__wrapper'>
        <button className='team__scroll-btn team__scroll-btn--left' onClick={scrollLeft}>
          ◀ {/* Icône flèche gauche */}
        </button>
        
        <div className='team__card-container' ref={cardContainerRef}>
          <div className='team__card card p-3'>
            <div className='team_bloc_image'>
              <img src={Yannik} alt="John Doe" className='img-fluid rounded-circle' />
            </div>
            <div className='team_bloc_title text-center'>
              <h4>Yannick Matuta</h4>
              <h6>Charger d’étude</h6>
            </div>
            <div className='team_bloc_desc'>
              <p>Expert en gestion de projet</p>
            </div>
            <div className='team_bloc_btn'>
              <button>En savoir plus</button>
            </div>
          </div>
          <div className='team__card card p-3'>
            <div className='team_bloc_image'>
              <img src={Jacque} alt="Jacques NSIMBA" className='img-fluid rounded-circle'/>
            </div>
            <div className='team_bloc_title'>
              <h4>Jacques Nsimba</h4>
              <h6>DevOps</h6>
            </div>
            <div className='team_bloc_desc'>
              <p>Architecte en solutions de données</p>
            </div>
            <div className='team_bloc_btn'>
              <button>En savoir plus</button>
            </div>
          </div>
          <div className='team__card card p-3'>
            <div className='team_bloc_image'>
              <img src={Timothee} alt="John Doe" className='img-fluid rounded-circle'/>
            </div>
            <div className='team_bloc_title'>
              <h4>Timothée Wolumona</h4>
              <h6>Responsable commercial</h6>
            </div>
            <div className='team_bloc_desc'>
              <p>Expert B2B</p>
            </div>
            <div className='team_bloc_btn'>
              <button>En savoir plus</button>
            </div>
          </div>
          <div className='team__card card p-3'>
            <div className='team_bloc_image'>
              <img src={David} alt="David Katende" className='img-fluid rounded-circle' />
            </div>
            <div className='team_bloc_title'>
              <h4>David Katende</h4>
              <h6>Responsable Administratif</h6>
            </div>
            <div className='team_bloc_desc'>
              <p>Ressource humaine</p>
            </div>
            <div className='team_bloc_btn'>
              <button>En savoir plus</button>
            </div>
          </div>

          <div className='team__card card p-3'>
            <div className='team_bloc_image'>
              <img src={Rhenard} alt="Julia Odiona" className='img-fluid rounded-circle'/>
            </div>
            <div className='team_bloc_title'>
              <h4>Rhenard Bonkey</h4>
              <h6>Develper Full-Stack</h6>
            </div>
            <div className='team_bloc_desc'>
              <p>Expert en ingénierie et innovation</p>
            </div>
            <div className='team_bloc_btn'>
              <button>En savoir plus</button>
            </div>
          </div>

          <div className='team__card card p-3'>
            <div className='team_bloc_image'>
              <img src={Julia} alt="Julia Odiona" className='img-fluid rounded-circle'/>
            </div>
            <div className='team_bloc_title'>
              <h4>Julia Odiona</h4>
              <h6>Responsable marketing</h6>
            </div>
            <div className='team_bloc_desc'>
              <p>Experte en Business Intelligence </p>
            </div>
            <div className='team_bloc_btn'>
              <button>En savoir plus</button>
            </div>
          </div>

          <div className='team__card card p-3'>
            <div className='team_bloc_image'>
              <img src={Ebrille} alt="Julia Odiona" className='img-fluid rounded-circle'/>
            </div>
            <div className='team_bloc_title'>
              <h4>Julia Odiona</h4>
              <h6>Com & Marketing</h6>
            </div>
            <div className='team_bloc_desc'>
              <p>Experte en communication</p>
            </div>
            <div className='team_bloc_btn'>
              <button>En savoir plus</button>
            </div>
          </div>

          <div className='team__card card p-3'>
            <div className='team_bloc_image'>
              <img src={Peter} alt="Julia Odiona" className='img-fluid rounded-circle'/>
            </div>
            <div className='team_bloc_title'>
              <h4>Peter Wenzime</h4>
              <h6>Responsable de terrain</h6>
            </div>
            <div className='team_bloc_desc'>
              <p>Expert en collecte de données</p>
            </div>
            <div className='team_bloc_btn'>
              <button>En savoir plus</button>
            </div>
          </div>

        </div>

        <button className='team__scroll-btn team__scroll-btn--right' onClick={scrollRight}>
          ▶ {/* Icône flèche droite */}
        </button>
      </div>
    </div>
  );
};

export default TeamSection;
